import { ChannelType, DeliveryMethodOptions, FileFormat, JSONDeliveryConfiguration } from '@fabric-ui/components/Table';
import { COMPRESSION_OPTION_GZIP, COMPRESSION_OPTION_NONE, COMPRESSION_OPTION_ZIP, COMPRESSION_OPTION_ZST } from './ExportPopper/constants';

export type ExportDetails = {
  enabled: boolean;
  intervalExpression: string;
  deliveryConfig?: DeliveryConfig;
} & JSONDeliveryConfiguration;

export type DeliveryConfig = {
  integrationId: string | null;
  title?: string;
  message?: string;
  type: DeliveryMethodOptions;
  path?: string;
  attachmentMetadata?: {
    fileFormat?: FileFormat;
    // Only applies to JSON exports: when true, JSON keys use display names instead of system names.
    useDisplayName?: boolean;
  };
  recipients?: string[];
  channel?: string;
  channelType?: ChannelType;
  channelId?: string;
  compressFile?: boolean;
  compressType?:
    | typeof COMPRESSION_OPTION_NONE.value
    | typeof COMPRESSION_OPTION_ZIP.value
    | typeof COMPRESSION_OPTION_ZST.value
    | typeof COMPRESSION_OPTION_GZIP.value;
  splitExportFiles?: boolean;
  schedulerOwner?: string | null;
};

export const defaultExportDetails: ExportDetails = {
  enabled: false,
  intervalExpression: '0 0 * * *',
  deliveryConfig: {
    schedulerOwner: null,
    integrationId: null,
    type: DeliveryMethodOptions.Email,
    recipients: [],
    title: '',
    message: '',
    attachmentMetadata: {
      fileFormat: FileFormat.EXCEL_FORMAT,
    },
  },
};
